import { createAction, props } from '@ngrx/store';

export const setLocationTree = createAction('[Location] Set Location Tree', props<{ locationTree: any }>());

export const setLocationList = createAction('[Location] Set Location List', props<{ locationList: any }>());

export const setReceiverLocations = createAction('[Location] Set Receiver Locations', props<{ receiverLocations: any }>());

export const setExternalLocations = createAction('[Location] Set External Locations', props<{ externalLocations: any }>());

export const setSenderLocationsTree = createAction('[Location] Set Sender Locations By Customer Tree', props<{ senderLocationTree: any }>());
export const setSenderLocations = createAction('[Location] Set Sender Locations By Customer', props<{ senderLocations: any }>());

export const setCustomerLocationTree = createAction('[Location] Set Customer Location Tree', props<{ customerLocationTree: any }>());
export const setCustomerLocationList = createAction('[Location] Set Customer Location List', props<{ customerLocationList: any }>());

export const selectedLocations = createAction('[Location] Selected Node Locations', props<{ selectedLocations: number[] }>());

export const clearLocationTree = createAction('[Location] Clear Location Tree');